import { ActionConstraint } from 'lib/constraintsChecker/ActionConstraint';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { CustomRule } from 'lib/constraintsChecker/constants';
import { ActionMessage } from 'lib/constraintsChecker/ActionMessage';
import { ActionMessageResponse } from 'lib/constraintsChecker/ActionMessageResponse';
import { getMessages } from 'lib/constraintsChecker/data';

export type RuleScope = typeof Cabinet | typeof Shelf;

export class Rule {
  name?: string;
  description: string;
  scope: RuleScope;
  nextCondition: string;
  currentCondition: string;
  action: ActionConstraint;
  reverse: boolean;
  webshop: boolean;
  shops: boolean;
  projects: boolean;
  custom: CustomRule;

  constructor(
    description: string,
    scope: RuleScope,
    nextCondition: string,
    currentCondition: string,
    action: ActionConstraint,
    reverse: boolean,
    webshop: boolean,
    shops: boolean,
    projects: boolean,
    custom: CustomRule = CustomRule.both,
    name?: string,
  ) {
    this.description = description;
    this.scope = scope;
    this.nextCondition = nextCondition;
    this.currentCondition = currentCondition;
    this.action = action;
    this.reverse = reverse;
    this.webshop = webshop;
    this.shops = shops;
    this.projects = projects;
    this.custom = custom;
    if (name) this.name = name;
  }

  static fromJSON(json: any): Rule {
    let objMessage: ActionMessage | null = null;
    const responsesArray: ActionMessageResponse[] = [];
    if (json.action && json.action.message) {
      if (typeof json.action.message === 'number') {
        const messages = getMessages();
        for (const msg of messages) {
          if (msg.id === json.action.message) {
            objMessage = msg;
            break;
          }
        }
      } else {
        objMessage = json.action.message;
      }

      if (json.action.responses) {
        for (const response of json.action.responses) {
          let actionMessageStr = '';
          if (typeof response.content === 'number') {
            const messages = getMessages();
            for (const msg of messages) {
              if (msg.id === response.content) {
                actionMessageStr = msg.content;
                break;
              }
            }
          } else {
            actionMessageStr = response.content;
          }

          responsesArray.push({
            content: actionMessageStr,
            action: response.action,
          });
        }
      }
    }

    const rule = Object.create(Rule.prototype);
    let scopeRule: RuleScope = Cabinet;
    if (json.scope === 'Shelf') scopeRule = Shelf;

    Object.assign(rule, this, json, {
      scope: scopeRule,
    });

    if (objMessage !== null) {
      Object.assign(rule, {
        action: { ...json.action, message: objMessage },
      });
    }

    if (responsesArray.length > 0) {
      Object.assign(rule, {
        action: { ...rule.action, responses: responsesArray },
      });
    }

    return rule;
  }

  static reviver(key: string, value: any): any {
    return key === '' ? Rule.fromJSON(value) : value;
  }
}
